module.exports = __webpack_public_path__ + "img/sld_scb_28_t1_b1_green.bd91d1e6.svg";